import { gql } from "@apollo/client";

const AvailableDevices = gql`
  query AvailableDevices {
    allDevices(condition: { isActive: true }, orderBy: DEVICE_NAME_ASC) {
      nodes {
        id
        latitudeField
        longitudeField
        altitudeField
        orientedImageryType
        headingField
        timeField
        timestampFormat
        deviceName
        fileFormat
        isActive
        dateTimeField
        dateField
      }
    }
  }
`;

const hash = "60299e346ba1a2464b3b3e4798b58068b0ab8a8ea365ef5222f40b8b923c9f2e";

export { AvailableDevices, hash };
